export const BRAND = {
  primary: "#6366f1",
  primaryDark: "#4f46e5",
  primaryLight: "#eef2ff",
  secondary: "#8b5cf6",
  secondaryDark: "#7c3aed",
  secondaryLight: "#ede9fe",
  cyan: "#38bdf8",
  cyanDark: "#0ea5e9",
  cyanLight: "#e0f2fe",
  purple: "#a855f7",
  purpleDark: "#9333ea",
  purpleLight: "#f3e8ff",
  navy: "#0a0e27",
  navyDeep: "#050816",
  charcoal: "#1e1b4b",
  textOnDark: "#e0e7ff",
  white: "#ffffff",
};

export const GRADIENTS = {
  brand: `linear-gradient(135deg, ${BRAND.cyan}, ${BRAND.purple})`,
  brandSoft: `linear-gradient(135deg, ${BRAND.cyanDark}, ${BRAND.purpleDark})`,
  primary: `linear-gradient(135deg, ${BRAND.primary}, ${BRAND.secondary})`,
  primaryVertical: `linear-gradient(180deg, ${BRAND.primary}, ${BRAND.secondary})`,
  dark: `linear-gradient(135deg, ${BRAND.navy}, ${BRAND.charcoal})`,
  hero: `radial-gradient(ellipse at 30% 20%, ${BRAND.cyan}33 0%, transparent 50%), radial-gradient(ellipse at 70% 80%, ${BRAND.purple}33 0%, transparent 50%), linear-gradient(180deg, ${BRAND.navy} 0%, ${BRAND.navyDeep} 100%)`,
};

export const SHADOWS = {
  brand: `0 8px 32px ${BRAND.primary}40`,
  brandHover: `0 12px 48px ${BRAND.primary}66`,
  glow: `0 0 48px ${BRAND.cyan}4d, 0 0 96px ${BRAND.purple}33`,
};

export const LOGO = {
  full: "/static/media/talktokam.webp",
  fullPath: "src/assets/images/talktokam.webp",
  height: { sm: 32, md: 40, lg: 56, xl: 80 },
};

export default BRAND;
